export default __webpack_public_path__ + "static/media/flag-virgin-islands-(british).7ba76ef0.svg";